import actions from './actions';

const initState = {
	dataFillInTheBlanks: [],
	fillInTheBlanksDetail: {},
	totalItems: 0,
	loading: false,
};

export default function fillInTheBlanksReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_FILL_IN_THE_BLANKS:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_FILL_IN_THE_BLANKS_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataFillInTheBlanks: res, totalItems, loading: false };

		case actions.GET_FILL_IN_THE_BLANKS_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_FILL_IN_THE_BLANKS_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, fillInTheBlanksDetail: res, loading: false };
		}

		case actions.LISTENING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
